// extracted by mini-css-extract-plugin
export default {"mainContainer":"TEachAudioCard_mainContainer__3VybN"};